<script lang="ts">
import { useDesignStore } from '@/stores/designStore.ts'

export default {
  props: ['title'],
  setup(props, context) {
    const designStore = useDesignStore()
    return { props, designStore }
  }
}
</script>
<template>
  <div style="display: flex; align-items: center">
    <h5 style="text-wrap: nowrap; align-self: center; margin-bottom: 0; padding-right: 0.25rem">
      {{ title }}
    </h5>
    <hr
      :style="{ borderColor: designStore.secondaryTheme }"
      style="align-self: center; position: relative; top: 0rem"
    />

    <v-icon
      name="gi-abstract-119"
      style="position: relative; right: 0.25rem; align-self: center"
      :style="{ color: designStore.secondaryTheme }"
    ></v-icon>
  </div>
</template>
